import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[allowInput]',
  standalone: false,
})
export class AllowInputDirective<K> implements OnInit {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);

  private _values: K[] = [];

  private _key!: K;

  @Input()
  set allowInputValues(value: K[] | undefined) {
    this._values = value ?? [];
  }

  @Input()
  set allowInput(key: K) {
    this._key = key;
  }

  ngOnInit() {
    if (!this._values.includes(this._key)) {
      this.viewContainer.clear();
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
